module.exports = __webpack_public_path__ + "static/media/health.628e9ddb.svg";